import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Layout/Header';
import Navigation from './components/Layout/Navigation';
import Footer from './components/Layout/Footer';
import Home from './pages/Home';
import Data from './pages/Data';
import Estimands from './pages/Estimands';
import Assumptions from './pages/Assumptions';
import Submissions from './pages/Submissions';
import Evaluation from './pages/Evaluation';
import Results from './pages/Results';
import FAQ from './pages/FAQ';
import NoPage from './pages/NoPage';
import './App.css';

const App = () => {
  return (
    <div className="App">
      <Header />
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="data" element={<Data />} />
          <Route path="estimands" element={<Estimands />} />
          <Route path="assumptions" element={<Assumptions />} />
          <Route path="evaluation" element={<Evaluation />} />
          <Route path="submissions" element={<Submissions />} />
          <Route path="results" element={<Results />} />
          <Route path="faq" element={<FAQ />} />
          <Route path="*" element={<NoPage />} />
        </Routes>
      </BrowserRouter>
      <Footer />      
    </div>
  );
}

export default App;
